export default __webpack_public_path__ + "static/media/apple-icon.3c3af54d.webp";